<template>
  <!-- 配送地址 -->
  <div class="address-item">
    <van-address-edit
      :address-info="addressInfo"
      :area-list="areaList"
      @save="onSave"
      :tel-validator="validator"
    />
  </div>
</template>

<script>
/* eslint-disable */
import { AddressEdit as VanAddressEdit, Toast as VanToast } from 'vant';
import areaList from '../lib/area';
import address from '../services/address';

export default {
  name: 'AddressDetail',
  data() {
    return {
      areaList: {},
      params: {},
      item: {
        id: '2',
        name: '李四',
        tel: '1310000000',
        address: '浙江省杭州市拱墅区莫干山路 50 号',
      },
      addressInfo: {},
    };
  },
  mounted() {

    this.areaList = areaList;

    const id = this.$route.params.id;

    if (id > 0) {
      this.getAddressInfo(id);
    }
  },
  components: {
    VanAddressEdit,
  },
  methods: {
    // 手机号自定义验证
    validator(e) {
      if (e.length == 11 && /0?(13|14|16|19|15|18|17)[0-9]{9}/.test(e)) {
        return true;
      }
    },
    getKeyFn(list, val) {
      const findKey = (value, compare = (a, b) => a === b) => {
        return Object.keys(list).find((k) => compare(list[k], value));
      };
      return findKey(val);
    },

    // 点击保存按钮时触发 e是表单内容
    onSave(e) {
      this.params.receiver_name = e.name;
      this.params.receiver_phone = e.tel;
      this.params.receiver_province = this.getKeyFn(
        this.areaList.province_list,
        e.province
      );
      this.params.receiver_city = this.getKeyFn(
        this.areaList.city_list,
        e.city
      );
      this.params.receiver_area = this.getKeyFn(
        this.areaList.county_list,
        e.county
      );
      this.params.receiver_address = e.addressDetail;
      this.params.patient_id = this.$store.getters.getUserInfo.patientId;
      if (this.$route.params.id > 0) {
     
        this.params.id = this.$route.params.id;
        address
          .updateUserAddressById(this.params)
          .then((res) => {
            if (res.data.status === 'success') {
              VanToast.success('更新成功');
              setTimeout(() => {
                this.$router.push({
                  path: this.$route.query.url,
                  query: {
                    id: this.$route.params.id,
                  },
                });
              }, 1000);
            }
          })
          .catch(() => {});
      } else {

        address
          .addAddress(this.params)
          .then((res) => {

            if (res.data.status === 'success') {
              VanToast.success('添加成功');
     

              setTimeout(() => {
           
                this.$router.push({
                  path: this.$route.query.url,
                  query: {
                    id: res.data.data.id,
                  },
                });
              }, 1000);
            }
          })
          .catch(() => {});
      }
    },

    getAddressInfo(id) {
   
      address
        .getUserAddressById({
          patient_id: this.$store.getters.getUserInfo.patientId,
          id,
        })
        .then((res) => {
          const data = res.data.data;
          // 给addressInfo 添加属性名和属性值
          this.$set(this.addressInfo, 'name', data.receiver_name);
          this.$set(this.addressInfo, 'tel', data.receiver_phone);
          this.$set(
            this.addressInfo,
            'province',
            this.areaList.province_list[data.receiver_province]
          );
          this.$set(
            this.addressInfo,
            'city',
            this.areaList.city_list[data.receiver_city]
          );
          this.$set(
            this.addressInfo,
            'county',
            this.areaList.county_list[data.receiver_area]
          );
          this.$set(this.addressInfo, 'addressDetail', data.receiver_address);
          this.$set(this.addressInfo, 'areaCode', data.receiver_area);
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
</style>
<style lang="less">
.address-item {
  .van-switch--on {
    background: #30b972;
  }
  .van-button--danger {
    font-size: 18px;
    background: #208fe3;
    border-radius: 4px;
    border: 1px solid #208fe3;
  }
}
</style>
